import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './Views/App';
import 'antd/dist/antd.css';
import { Provider } from 'react-redux';
import store from './Redux/store/store';
import { Auth0Provider } from './react-auth0-spa';
import config from './auth_config.json';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import SignUp from './Views/SignUp';
import Logout from './Views/Logout';

// A function that routes the user to the right place
// after login
const onRedirectCallback = (appState) => {
  window.history.replaceState(
    {},
    document.title,
    appState && appState.targetUrl
      ? appState.targetUrl
      : window.location.pathname
  );
};

ReactDOM.render(
  <Auth0Provider
    domain={config.domain}
    client_id={config.clientId}
    redirect_uri={window.location.origin}
    onRedirectCallback={onRedirectCallback}
    audience={config.audience}
    issuer={config.issuer}
    useRefreshTokens={true}
    cacheLocation={'localstorage'}
  >
    <Provider store={store}>
      <BrowserRouter>
        <Switch>
          <Route path="/signup" component={SignUp} />
          <Route path="/logout" component={Logout} />
          <Route path="/" component={App} />
        </Switch>
      </BrowserRouter>
    </Provider>
    ,
  </Auth0Provider>,
  document.getElementById('root')
);
